// extracted by mini-css-extract-plugin
export var readonly = "_fi-1";
export var star = "_fi-0";